export default "assets/images/927c34e7b9b2f95c82ba477993117eaf.png";